import {
    EventVariantsWithAllocationsCountDocument,
    ExternalEventVariantsWithAllocationsCountDocument,
    ProjectVariantsWithAllocationsCountDocument,
} from '@/generated/graphql';
import { useQuery } from '@vue/apollo-composable';
import { computed, Ref, toValue } from 'vue';

type HasAllocationsDocument =
    | typeof EventVariantsWithAllocationsCountDocument
    | typeof ProjectVariantsWithAllocationsCountDocument
    | typeof ExternalEventVariantsWithAllocationsCountDocument;

export function useHasAllocations(document: HasAllocationsDocument, objectId: Ref<string>) {
    const { result, refetch } = useQuery(
        document,
        () => ({ id: toValue(objectId) }),
        () => ({ enabled: !!toValue(objectId), fetchPolicy: 'network-only' }),
    );

    const hasAllocations = computed(() =>
        result.value?.object ? result.value?.object?.variantsWithAllocationsCount.totalCount > 0 : false,
    );

    return { hasAllocations, refetchHasAllocations: refetch };
}
